import { render, staticRenderFns } from "./closure.vue?vue&type=template&id=594cac24&"
import script from "./closure.vue?vue&type=script&lang=ts&"
export * from "./closure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "closure.vue"
export default component.exports